import { render, staticRenderFns } from "./RouteBack.vue?vue&type=template&id=083cbeb5"
import script from "./RouteBack.vue?vue&type=script&lang=js"
export * from "./RouteBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports